import { graphql } from "../gql";

export const getInsurersQueryDoc = graphql(`
  query getInsurers($orderBy: [InsurersOrderBy!]) {
    insurers(orderBy: $orderBy) {
      nodes {
        ...InsurerFragment
      }
    }
  }
`);
